import { FC, PropsWithChildren } from 'react'
import classNames from 'classnames'
import { Alert } from '@components-v2/atoms/Alert'
import styles from './index.module.scss'

type Props = {
  location?: 'pageTop' | 'sidebar' | 'message'
  styleType?: 'danger' | 'warning'
}

export const AlertBanner: FC<PropsWithChildren<Props>> = ({ children, location = 'pageTop', styleType = 'danger' }) => {
  const className = classNames(styles.container, {
    [styles.pageTopContainer]: location === 'pageTop',
    [styles.sidebarContainer]: location === 'sidebar',
    [styles.messageContainer]: location === 'message',
  })

  const align = location === 'sidebar' ? 'flexStart' : 'center'

  return (
    <div className={className}>
      <div className='container'>
        <Alert styleType={styleType} align={align}>
          {children}
        </Alert>
      </div>
    </div>
  )
}
